module.exports = __webpack_public_path__ + "static/media/top-banner.a191403a.png";